module.exports = __webpack_public_path__ + "img/UTCAMP.b725a1c1.png";